"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactMarkdown = require("react-markdown");

var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);

var _mathjax = require("@nteract/mathjax");

var _mathjax2 = _interopRequireDefault(_mathjax);

var _remarkMath = require("./remark-math");

var _remarkMath2 = _interopRequireDefault(_remarkMath);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var math = function math(props) {
  return _react2.default.createElement(
    _mathjax2.default.Node,
    null,
    props.value
  );
};

var inlineMath = function inlineMath(props) {
  return _react2.default.createElement(
    _mathjax2.default.Node,
    { inline: true },
    props.value
  );
};

var MarkdownRender = function MarkdownRender(props, context) {
  var newProps = _extends({}, props, {
    escapeHtml: false,
    plugins: [_remarkMath2.default],
    renderers: _extends({}, props.renderers, {
      math: math,
      inlineMath: inlineMath
    })
  });

  // Render a Context if one was not passed as a parent
  if (!context.MathJaxContext) {
    return _react2.default.createElement(
      _mathjax2.default.Context,
      { input: "tex" },
      _react2.default.createElement(_reactMarkdown2.default, newProps)
    );
  }

  return _react2.default.createElement(_reactMarkdown2.default, newProps);
};

MarkdownRender.contextTypes = {
  // Opt in to updates to the MathJax object even though
  // Not explicitly used
  MathJax: _propTypes2.default.object,
  MathJaxContext: _propTypes2.default.bool
};

var _default = MarkdownRender;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(math, "math", "src/index.js");
  reactHotLoader.register(inlineMath, "inlineMath", "src/index.js");
  reactHotLoader.register(MarkdownRender, "MarkdownRender", "src/index.js");
  reactHotLoader.register(_default, "default", "src/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/@nteract/markdown/lib/index.js
// module id = 121
// module chunks = 186292428941015